import { C } from "@/brand/tokens";

/**
 * FaithMark — primary wordmark.
 *
 * Tones map to the new palette:
 *   - "light"  — Witness White (on dark surfaces, default)
 *   - "ink"    — Smoked Ink (on dry stone / parchment)
 *   - "brass"  — Restrained Brass (accent variant)
 *
 * `subtitle` — the uppercase line beneath the rule. Defaults to
 * "Executive Advisory" so the archived concepts remain unchanged;
 * the Concept 5 header/footer override it to
 * "Leadership, People & Culture."
 *
 * Set in Cormorant Garamond above a centered rule and the
 * subtitle in Inter.
 */
export function FaithMark({
  tone = "light",
  size = "md",
  showSubtitle = true,
  subtitle = "Executive Advisory",
}) {
  const color =
    tone === "ink" ? C.textOnLight : tone === "brass" ? C.accentMetal : C.textOnDark;
  const dims = {
    sm: { word: 28, rule: 1, sub: 9.5, ruleW: "82%", subLetter: "0.36em" },
    md: { word: 38, rule: 1, sub: 10.5, ruleW: "82%", subLetter: "0.36em" },
    lg: { word: 52, rule: 1.25, sub: 11.5, ruleW: "82%", subLetter: "0.38em" },
  }[size];

  return (
    <span
      className="inline-flex flex-col items-center select-none leading-none"
      aria-label="Faith 1st Executive Advisory"
    >
      <span
        className="font-cormorant"
        style={{
          color,
          fontSize: `${dims.word}px`,
          fontWeight: 500,
          lineHeight: 1,
          letterSpacing: "-0.01em",
        }}
      >
        Faith
        <span style={{ marginLeft: "0.18em" }}>1</span>
        <sup
          className="font-cormorant"
          style={{
            fontSize: "0.42em",
            verticalAlign: "0.85em",
            marginLeft: "0.04em",
            fontWeight: 500,
          }}
        >
          st
        </sup>
      </span>
      {showSubtitle && (
        <>
          <span
            style={{
              background: color,
              height: dims.rule,
              width: dims.ruleW,
              marginTop: dims.word * 0.18,
              marginBottom: dims.word * 0.18,
            }}
          />
          <span
            className="font-inter"
            style={{
              color,
              fontSize: `${dims.sub}px`,
              fontWeight: 500,
              letterSpacing: dims.subLetter,
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}
          >
            {subtitle}
          </span>
        </>
      )}
    </span>
  );
}
